import { FCC, Icon, TabProps, TabStyleProps, useTab } from "@dgs/core";
import { Link } from "react-router";
import styled from "styled-components";

interface LinkTabProps extends TabProps {
	hasError?: boolean;
}

const StyledTab = styled(Link)<TabStyleProps & { $hasError?: boolean }>`
	${({ theme }) => theme.tabs.links.tab};
`;

const Container = styled.div<TabStyleProps>`
	${({ theme }) => theme.tabs.links.tabContent};
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.25rem;
`;

const StyledIcon = styled(Icon)`
	width: 1.25rem;
	height: 1.25rem;
	color: ${({ theme }) => theme.colors.palette.danger.main.base};
`;

export const LinkTabWithError: FCC<LinkTabProps> = ({
	children,
	to,
	className,
	exact = false,
	replace = false,
	hasError = false,
}) => {
	const { ref, isActive } = useTab(exact, to);

	return (
		<StyledTab ref={ref} to={to} replace={replace} className={className} $active={isActive} $hasError={hasError}>
			<Container $active={isActive}>
				{hasError && <StyledIcon $icon="warning" />}
				{children}
			</Container>
		</StyledTab>
	);
};
